
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { PageName } from 'src/app/core/enums';
import { ErrorCode } from 'src/app/core/enums/ErrorCode';
import { ProfileService } from './../services/profile.service';
import { ToastData } from 'src/app/core/models/ToastData';
import { ToastService } from 'src/app/shared/services/toast.service';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  providers: [ProfileService]
})
export class ResetPasswordComponent implements OnInit {
  pageName = PageName.ResetPasswordPage;
  errorCodes: any = ErrorCode;
  errorCode: any;

  constructor(
    private profileService: ProfileService,
    private toastService: ToastService,
    private navigationService: NavigationService
  ) { }

  ngOnInit(): void { }

  async onFormSubmit(dt: any) {
    let newPw = dt?.newPassword ? dt.newPassword : "";
    let currentPw = dt?.currPassword ? dt.currPassword : '';

    let resp: any = await this.profileService.onUpdatePassword(currentPw, newPw);

    if (resp instanceof HttpErrorResponse) {
      if (resp.error.errorCode === this.errorCodes.PasswordMisMatch_400) {
        this.errorCode = resp.error.errorCode;
      } else {
        this.navigationService.navigate(['profiles']);
        let toastData = {} as ToastData;
        toastData.failStatus = true;
        toastData.message = "error.change.password.unsuccessful";
        this.toastService.show(toastData);
      }
    } else {
      this.navigationService.navigate(['profiles']);
      let toastData = {} as ToastData;
      toastData.successStatus = true;
      toastData.message = "desc.updated.successfully";
      this.toastService.show(toastData);
    }
  }

  onClickBack() {
    this.navigationService.navigate(['profiles']);
  }
}


